import { motion } from 'motion/react';

const AnimatedPath = (props) => (
  <motion.path
    {...props}
    initial={{ pathLength: 0 }}
      animate={{ pathLength: 1 }}
      exit={{ pathLength: 0, transition:{
        duration: 0.3,
        ease: "easeInOut",
      }}}
      transition={{
          duration: 1,
          ease: "easeInOut",
      }}
  ></motion.path>
);

export default AnimatedPath;